module.exports = __webpack_public_path__ + "rw.b586ef69.svg";